import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { SERVER_URL, USER_TYPE_GUEST } from '../constants';
import moving from '../moving.png';
import {Box} from '@mui/material';

function Moving (props) {

    useEffect(() => {
        if (props.isAuthenticated && props.userType != USER_TYPE_GUEST)
        {
            if (checkLastOpened() === true)
            {
                handleOpen();
            }
        }
        else {
            handleClose();
        }
    }, [props.isAuthenticated, props.userType]);

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        const currentDate = new Date();
        const dateString = currentDate.toISOString();
        localStorage.setItem("movingDialogLastOpened", dateString);
    };

    const checkLastOpened = () => {
        const savedDateString = localStorage.getItem("movingDialogLastOpened");

        if (savedDateString) {
            const savedDate = new Date(savedDateString);
            const currentDate = new Date();

            // Difference in milliseconds
            const diffInMs = currentDate - savedDate;

            // One day in ms
            const oneDayMs = 24 * 60 * 60 * 1000;

            if (diffInMs > oneDayMs) {
                console.log("savedDate is older than one day ago.");
                return true;
            } else {
                console.log("savedDate is within the last day.");
                return false;
            }
        } else {
            console.log("No saved date found in localStorage.");
            return true;
        }
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };


    return(
        <React.Fragment>
            <Dialog open={open}
            sx={{
                "& .MuiDialog-container": {
                  "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "500px",  // Set your width here
                  },
                },
            }}
            style={{
                zIndex: 1302,
            }}
            >
                <DialogContent sx={{ m: 0, p: 4 }}>
                    <Box sx={{ textAlign: "center" }}>
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        <b>Goodbye Qonsulta. <br />Hello Qyumo!</b>
                    </Typography>
                    <img src={moving} alt="" height={150} />
                    </Box>


                    <Typography sx={{ }} >                 
                    Starting <b>Jan 1, 2026</b>, Qonsulta will be winding down to give way to Qyumo. Our app will be available at:
                    </Typography>
                    <Typography sx={{ textAlign: "center", lineHeight: 3 }} variant='h6' >
                        <b>app.qyumo.com</b>
                    </Typography>
                    <Typography sx={{ }} >
                    Please log in there to continue without interruption.
                    </Typography>
  
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose}>
                        Got it
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default Moving;